import { useAppDispatch, useAppSelector } from "@builder/store/store.js";
import SidebarCollapse from "../../../app/SidebarCollapse";
import CustomCSS from "../../../general/CustomCSS";
import { EditableProps } from "../../editableProps";
import { getCustomCSS } from "@builder/store/slices/BuilderSlice/builderSelectors.js";

import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice.js";
//eslint-disable-next-line
//@ts-ignore
import { parseCSS } from "./parseCSS.js";

const Advanced: React.FC<EditableProps> = ({ parent }: EditableProps) => {
    const camelToKebab = (str: string): string => {
        return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    };

    const cssPropToString = (value: React.CSSProperties): string => {
        return Object.keys(value)
            .map(key => {
                return `${camelToKebab(key)}: ${(value as any)[key]};`;
            })
            .join("\n");
    };

    const dispatch = useAppDispatch();

    const customCSS = useAppSelector(getCustomCSS);

    const customCSSCallback = (value: string) => {
        if (!value) {
            dispatch(updateNodeProperty({ propertyPath: ["customCSS"], remove: true, value: {} }));
            return;
        }

        const parsedCSS = parseCSS(value);
        if (parsedCSS) {
            dispatch(updateNodeProperty({ propertyPath: ["customCSS"], remove: true, value: {} }));
            dispatch(updateNodeProperty({ propertyPath: ["customCSS"], value: parsedCSS }));
        }
    };

    return (
        <SidebarCollapse title="Advanced" parent={parent}>
            <CustomCSS callback={customCSSCallback} value={customCSS ? cssPropToString(customCSS) : ""} />
        </SidebarCollapse>
    );
};

export default Advanced;
